/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import {
    deletePAJAC060,
    getPAGAA000,
    getPAJAA010,
    getPAJAC020TaskManager,
    postPAJAC010,
    postPAJAC010CloneReady,
    postPAJAC010Delete,
    putPAJAC010Clone,
    putPAJAC010Expired,
    putPAJAC010JumpUp,
    putPAJAC010Reset,
    putPAJAC060,
} from '../../../services/Api';
import RecruitmentStatus from '../../../shared/components/RecruitmentStatus';
import SideNav from '../../../shared/components/SideNav';
import { MESSAGE } from '../../../shared/constants/app';
import { formatNumberWithCommas, handleFocus, shouldDisplayMenu, formatDate } from '../../../utils';

import CandidateList from '../../../shared/components/CandidateList';
import Pagination from '../../../shared/components/Pagination';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import ResumeTicketActions from '../../../shared/components/ResumeTicketActions';
import ResumeItem from '../../../shared/components/ResumeItem';
import Tabs from '../../../shared/components/Tabs';
import TicketStatistic from '../../../shared/components/TicketStatistic';
import TicketPurchase from '../../../shared/components/popup/TicketPurchase';
import { decodeHTML } from 'entities';

const PAJAA010 = () => {
    const [data, setData] = useState({});
    const [newsList, setNewsList] = useState([]);
    const [ticketStatistic, setTicketStatistic] = useState({});
    const [popupSendMailOpen, setPopupSendMailOpen] = useState(false);
    const [isTicketPurchasePopupOpen, setIsTicketPurchasePopupOpen] = useState(false);
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [menuData, setMenuData] = useState([]);

    const [recruits, setRecruits] = useState([]);
    const navigate = useNavigate();

    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [applies, setApplies] = useState([]);
    const [activeContentIndex, setActiveContentIndex] = useState(null);
    const [choices, setChoices] = useState([]);
    const [payload, setPayload] = useState({});

    const [activeIndex, setActiveIndex] = useState(null);
    const [activeMap, setActiveMap] = useState({});

    const codeLists = {
        A11: [],
    };
    const getListData = () => {
        getPAJAC020TaskManager().then((res) => (codeLists.A11 = res.data));
        getPAJAA010()
            .then(({ data }) => {
                setData(data);
                setNewsList(data.newsList);
                setApplies(data.applies);
                setChoices(data.choices);
                setTicketStatistic(data.ticketStatistic);
            })
            .catch((error) => console.log(error));
    };

    const getListRecuitData = () => {
        postPAJAC010({ page, size: 3 })
            .then(({ data }) => {
                setPages(data.info || {});
                setRecruits(
                    Array.isArray(data.data.list)
                        ? data.data.list?.map((item) => ({
                            ...item,
                            recruitClass: getCodeName(item.recruitClass, 'A11'),
                        }))
                        : [],
                );
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        const initialStates = {};
        if (Array.isArray(applies)) {
            applies.forEach((item) => {
                initialStates[item.seq] = {
                    result: item.result || 'W',
                    reasonType: '',
                    reason: item.reason || '',
                };
            });
        }
        setPayload(initialStates);
    }, [applies]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                setMenuData(data);
            })
            .catch((error) => console.log(error));

        getListRecuitData();
        getListData();
    }, []);

    useEffect(() => {
        getListData();
        getListRecuitData();
        // eslint-disable-next-line
    }, [page]);

    const closePopup = () => {
        setPopupSendMailOpen(false);
    };

    const handleJumpUp = (seq) => {
        putPAJAC010JumpUp(seq)
            .then(() => {
                getListData();
                getListRecuitData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => console.log(error));
    };

    const handleResetViewCount = (seq) => {
        putPAJAC010Reset(seq)
            .then(() => {
                getListData();
                getListRecuitData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => console.log(error));
    };

    const handleExpired = (seq) => {
        if (window.confirm('채용 공고를 마감하시겠습니까?')) {
            putPAJAC010Expired(seq)
                .then(() => {
                    getListData();
                    getListRecuitData();
                    window.alert(MESSAGE.notify.updateSuccess);
                })
                .catch((error) => console.log(error));
        }
    };

    const handleClone = (seq) => {
        putPAJAC010Clone(seq)
            .then(() => {
                getListData();
                getListRecuitData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => console.log(error));
    };

    const handleCloneReady = (seq) => {
        postPAJAC010CloneReady(seq)
            .then(() => {
                getListData();
                getListRecuitData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => console.log(error));
    };

    const handleOption = (type, seq) => {
        navigate(`/pajac020-${seq}?step=2&type=${type}&option=true`);
    };

    const tabs = useMemo(
        () => [
            { label: '지원자 현황', isActive: true },
            { label: '스크랩 인재', isActive: false },
        ],
        [],
    );

    const handleTabChange = useCallback((index) => {
        setActiveTabIndex(index);
    }, []);

    const handleChangeDropdown = (selectedValue, name) => {
        const parts = name.split('-');
        const seq = parts[parts.length - 1];
        const type = parts.length === 3 ? 'reason-type' : parts[0];

        setPayload((prev) => {
            const newState = { ...prev[seq] } || {};
            if (type === 'status') {
                newState.result = selectedValue;
                if (selectedValue !== 'F') {
                    newState.reasonType = '';
                    newState.reason = '';
                }
            } else if (type === 'reason-type') {
                newState.reasonType = selectedValue;
                newState.reason = selectedValue !== '직접입력' ? selectedValue : '';
            }
            return { ...prev, [seq]: newState };
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const seq = name.split('-')[1];
        setPayload((prev) => ({
            ...prev,
            [seq]: { ...prev[seq], reason: value },
        }));
    };

    const validateResult = (seq, statusMessage = '지원 결과를 선택해 주세요.') => {
        const { result, reason, reasonType } = payload[seq] || {};
        if (!result || result === 'W') {
            window.alert(statusMessage);
            handleFocus(`status-${seq}`);
            return false;
        }
        if (result === 'F' && !reasonType) {
            window.alert('불합격 사유를 선택해 주세요.');
            handleFocus(`reason-type-${seq}`);
            return false;
        }
        if (result === 'F' && reasonType === '직접입력' && !reason) {
            window.alert('불합격 사유를 입력해 주세요.');
            handleFocus(`reason-${seq}`);
            return false;
        }
        return true;
    };

    const handleDelete = async (item) => {
        const seq = item?.seq;

        const isWaiting = item?.resCancel === 'N' && item?.result === 'W';
        if (isWaiting) {
            if (!validateResult(seq, '합격/불합격 여부를 선택 후 삭제 가능합니다')) return;

            if (!window.confirm('삭제하시겠습니까?')) return;

            const saved = await handleSave(item, { silent: true });
            if (!saved) return;
        }

        deletePAJAC060(seq)
            .then(() => {
                getListData();
                getListRecuitData();
                window.alert(MESSAGE.notify.updateSuccess);
            })
            .catch((error) => {
                console.log(error);
                window.alert(MESSAGE.notify.updateError);
            });
    };

    const handleDeleteRecruit = (flag, seq) => {
        if (window.confirm('삭제하시겠습니까?')) {
            postPAJAC010Delete(flag, seq)
                .then(() => {
                    getListData();
                    getListRecuitData();
                    window.alert('삭제되었습니다.');
                })
                .catch((error) => console.log(error));
        }
    };

    const handleActiveContent = (index) => {
        setActiveContentIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const handleClickTitle = (item, index) => {
        setActiveMap(prev => ({
            ...prev,
            [index]: !(prev[index] ?? item?.contentView === 'Y'),
        }));
    };


    const handleSave = async (item, { silent = false } = {}) => {
        const seq = item.seq;
        const { result, reason } = payload[seq] || {};
        const confirm =
            result === 'P'
                ? '지원자에게 합격 통보를 하시겠습니까?'
                : result === 'F'
                    ? '전형 결과를 확정하시겠습니까? 확정 이후에는 수정이 불가능합니다.'
                    : '';

        const updatedPayload = { seq, result, reason };
        if (!validateResult(seq)) return false;
        if (!silent && !window.confirm(confirm)) return false;
        try {
            await putPAJAC060(updatedPayload);
            if (!silent) {
                getListData();
                window.alert(MESSAGE.notify.updateSuccess);
            }
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    };

    // Hàm getCodeName
    const getCodeName = (codes, key) => {
        const list = codeLists[key]; // Lấy danh sách tương ứng với key
        const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');
        // Nếu không tìm thấy danh sách cho key, trả về mảng null
        if (!list) {
            return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
        }
        // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
        const codeArray = Array.isArray(transformed) ? transformed : [transformed];

        // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
        const trimmedCodes = codeArray?.map((code) => code?.trim());
        const findCode = trimmedCodes.map((codeOrName) => {
            // Tìm theo code
            let found = list.find((item) => item.code === codeOrName);
            if (found) return found.code;
            // Tìm theo codeName
            found = list.find((item) => item.codeName === codeOrName);
            if (found) return found.code;
            // Không tìm thấy
            return '';
        });

        // Tìm codeName tương ứng cho từng mã đã được trim
        return findCode
            ?.sort((a, b) => Number(a) - Number(b))
            ?.map((code) => {
                const item = list?.find((item) => item?.code === code);
                return item
                    ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                    : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
            });
    };

    const getResumeTicketValue = (keys) => {
        const sources = [data?.statistic, ticketStatistic, data?.resumeTicketStatistic, data?.resumeTicket, data];

        for (const source of sources) {
            if (!source) continue;

            for (const key of keys) {
                const value = source[key];
                if (value !== undefined && value !== null && value !== '') {
                    return value;
                }
            }
        }

        return 0;
    };

    const remainingAccessCount = getResumeTicketValue(['remainingAccessCount']) || 0;
    const periodAccessStatus = getResumeTicketValue(['periodAccessStatus']) || '미사용';

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    {/* Top Sub Page */}
                    <div id="top-sub-page">
                        <SideNav />
                        <div style={{ width: '100%' }}>
                            <div id="info-dashboard" className="col">
                                <ul className="rsm-stt__list">
                                    <li className="rsm-stt__item">
                                        <span>게재중인 채용공고</span>
                                        <Link to="/pajac010" className="rsm-stt__num">{data.recruitCount || 0}</Link>
                                    </li>
                                    <li className="rsm-stt__item">
                                        <span>덴탈잡 지원자 (미열람 건)</span>
                                        <Link to="/pajad010" className="rsm-stt__num">{data.resumeNotViewed || 0}</Link>
                                    </li>
                                    <li className="rsm-stt__item">
                                        <span>스크랩</span>
                                        <Link to="/pajag010" className="rsm-stt__num">{data.resumeChoice || 0}</Link>
                                    </li>
                                    <li className="rsm-stt__item">
                                        <span>쪽지 (미열람 건)</span>
                                        <Link to="/pajah010" className="rsm-stt__num">{data.smsNotViewed || 0}</Link>
                                    </li>
                                </ul>
                                {/* Common User Info Setting */}
                                <div className="acs__block">
                                    <div className="acs__lf">
                                        <div className="acs__info">
                                            이용권 구매가능
                                            <br />
                                            <span>DV Point</span>
                                        </div>
                                        <div className="acs__point">
                                            <span>{formatNumberWithCommas(data.point)}</span> P
                                        </div>
                                        <button
                                            type="button"
                                            className="acs__btn"
                                            onClick={() => {
                                                window.open(
                                                    'https://www.dvmall.co.kr/product-list?cat=A30401&page=1&banner=1&best=0',
                                                    '_blank',
                                                );
                                            }}
                                        >
                                            DVmall 바로가기
                                        </button>
                                    </div>
                                    <div className="acs__right">
                                        <div className="acs__rt">
                                            <h3 className="acs__tit">
                                                미사용 덴탈잡 이용권 보유현황
                                                <button
                                                    type="button"
                                                    className="acs__more"
                                                    onClick={() => {
                                                        navigate('/pajae010');
                                                    }}
                                                >
                                                    <span>더보기</span>
                                                    <i className="icon icon-arrow-right" />
                                                </button>
                                            </h3>
                                            <TicketStatistic data={ticketStatistic} />
                                        </div>
                                        <div className="resume-ticket-summary">
                                            <div className="resume-ticket-summary__status">
                                                <div className="resume-ticket-summary__panel resume-ticket-summary__panel--blue">
                                                    <strong>이력서 일반 열람권</strong>
                                                    <span>보유현황</span>
                                                    <em>{remainingAccessCount}개</em>
                                                </div>
                                                <div className="resume-ticket-summary__panel resume-ticket-summary__panel--red">
                                                    <strong>이력서 자유 열람권</strong>
                                                    <span>열람 가능 시간</span>
                                                    <em className="resume-ticket-summary__unused">
                                                        {periodAccessStatus}
                                                    </em>
                                                </div>
                                            </div>
                                            <ResumeTicketActions onPurchaseClick={() => setIsTicketPurchasePopupOpen(true)} />
                                        </div>
                                    </div>
                                </div>
                                {/* End Common User Info Setting */}
                                {shouldDisplayMenu('pahaf010', menuData) && (
                                    <div id="notification" className="frame-section">
                                        <div className="header-frame">
                                            <h1>공지사항</h1>
                                            <Link to="/pahaf010">
                                                <span>더보기</span>
                                                <i className="icon icon-arrow-right" />
                                            </Link>
                                        </div>
                                        <div className="content-frame">
                                            <ul>
                                                {newsList?.map((item, index) => {
                                                    const isActive = activeMap[index] ?? item?.contentView === 'Y';

                                                    return (
                                                        <li key={'news_' + index} className={isActive ? 'active' : ''}>
                                                            <h1 onClick={() => handleClickTitle(item, index)}>
                                                                {item?.title}
                                                                <span className="date" style={{ float: 'right', fontSize: '14px', marginRight: '10px', color: '#999' }}>{formatDate(item?.addDate)}</span>
                                                            </h1>

                                                            {isActive && (
                                                                <div
                                                                    className="notify-image"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.content ? decodeHTML(item.content) : '',
                                                                    }}
                                                                />
                                                            )}

                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {/* End Info Dashboard */}
                            <div id="manage-recruitment-news" className="frame-section">
                                <div className="header-frame">
                                    <h1>채용정보 관리/영수증</h1>
                                    <Link to="/pajac010" className="top-link">
                                        채용정보 관리/영수증 바로가기
                                    </Link>
                                </div>
                                <RecruitmentStatus
                                    className={'bt0'}
                                    dataRecruit={recruits}
                                    handleJumpUp={handleJumpUp}
                                    handleResetViewCount={handleResetViewCount}
                                    handleExpired={handleExpired}
                                    handleClone={handleClone}
                                    handleDelete={handleDeleteRecruit}
                                    handleCloneReady={handleCloneReady}
                                    handleOption={handleOption}
                                />
                                <Pagination pages={pages} />
                            </div>
                            <div id="candidate-tab" className="frame-section">
                                <div className="header-frame">
                                    <Tabs tabs={tabs} className="short-tab" onTabChange={handleTabChange} />
                                    <Link to={activeTabIndex === 0 ? '/pajad010' : '/pajag010'}>
                                        <span>더보기</span>
                                        <i className="icon icon-arrow-right small" />
                                    </Link>
                                </div>
                                {activeTabIndex === 0 && (
                                    <>
                                        <ul className="dntInf__grid dntInf__head dntInf__candidate__head">
                                            <li style={{ padding: 0 }}>내용</li>
                                            <li style={{ padding: 0 }}>날짜</li>
                                            <li style={{ padding: 0 }}>전형결과/사유</li>
                                            <li style={{ padding: 0 }}>관리</li>
                                        </ul>
                                        <CandidateList
                                            data={applies}
                                            handleChangeDropdown={handleChangeDropdown}
                                            handleInputChange={handleInputChange}
                                            handleDelete={handleDelete}
                                            refreshData={getListData}
                                            setPopupSendMailOpen={setPopupSendMailOpen}
                                            setReceiver={setReceiver}
                                            payload={payload}
                                            handleSave={handleSave}
                                        />
                                    </>
                                )}
                                {activeTabIndex === 1 && (
                                    <div id="content-table">
                                        <div
                                            className="table table-header table-results"
                                            style={{ marginTop: '30px', borderTop: '1px solid #111' }}
                                        >
                                            <div className="column column-1" style={{ alignItems: 'center' }}>
                                                제목
                                            </div>
                                            <div className="column column-2">경력/형태/자격증</div>
                                            <div className="column column-3" style={{ paddingLeft: '0' }}>
                                                수정
                                            </div>
                                            <div className="column column-4">관리</div>
                                        </div>
                                        <ul className="table table-has-more-infomation PAJAA010">
                                            {choices && choices.length > 0 ? (
                                                choices?.map((result, index) => (
                                                    <ResumeItem
                                                        item={result}
                                                        key={index}
                                                        hasDelete={true}
                                                        refreshData={getListData}
                                                        showStar={false}
                                                        showEnvelope={true}
                                                        setPopupSendMailOpen={setPopupSendMailOpen}
                                                        setReceiver={setReceiver}
                                                        roleAction="C"
                                                        detailUrl="myPage"
                                                        setResumeList={setChoices}
                                                    />
                                                ))
                                            ) : (
                                                <li className="no-data">데이터없습니다</li>
                                            )}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
            {isTicketPurchasePopupOpen && <TicketPurchase onClose={() => setIsTicketPurchasePopupOpen(false)} />}
        </>
    );
};
export default PAJAA010;
